<li class="menu-node" (mouseenter)="onEnter()"(mouseleave)="onLeave()" [routerLink]="['/' + subCategories.name.replaceAll(' ', '-').toLowerCase() + '/c' + subCategories.category_key]">
  <div class="menu-label">{{ subCategories.name }}</div>
  <i class="fa-solid fa-angle-right white-arrow" [class]="{'fa-angle-left': flip}" *ngIf="subCategories.category_children?.length"></i>
  <ul *ngIf="subCategories.category_children?.length && isOpen" class="submenu flip-right" [class]="{'flip-left': flip}" (click)="$event.stopPropagation()">
    <app-header-cascading-link *ngFor="let child of subCategories.category_children" [subCategories]="child" [flip]="flip" />
  </ul>
</li>

 